import React from "react";
import { Typography } from "@/components/Typography";
import { PreviewCloudinaryImage } from "@/features/previews/shared/components";

interface LinksHeaderProps {
  logoUrl?: string;
  title?: string;
  description?: string;
  isInitPreview?: boolean;
}

export function LinksHeader({ logoUrl, title, description, isInitPreview }: LinksHeaderProps) {
  return (
    <div className="list-links-template__header">
      {logoUrl && (
        <div className="list-links-template__logo-container">
          <PreviewCloudinaryImage
            src={logoUrl}
            alt="link preview"
            variant="hero"
            isInitPreview={isInitPreview}
            className="list-links-template__logo"
          />
        </div>
      )}
      {title && (
        <div className="list-links-template__title">
          <Typography
            Tag="p"
            classname="u-semibold"
          >
            {title}
          </Typography>
        </div>
      )}
      {description && (
        <div className="list-links-template__subtitle">
          <Typography Tag="p">{description}</Typography>
        </div>
      )}
    </div>
  );
}
